import api from "..";

import { ZipCodeReturn } from "./types";
import { useEffect, useState } from "react";

const ZIP_CODE_REGEX = /[0-9]{5}-[0-9]{3}/;

export const validateZipCodeStructure = (zipCode: string) => {
  return ZIP_CODE_REGEX.test(zipCode);
};

export const fetchZipCode = async (zipCode: string, blockRequest?: boolean) => {
  if (!validateZipCodeStructure(zipCode) || blockRequest) {
    return undefined;
  }

  const response = await api.get(
    `/core/enderecos/${zipCode.replace(/-/g, "")}`
  );

  return response.data as ZipCodeReturn;
};

export const ZipCodeFetch = (zipCode: string, blockRequest?: boolean) => {
  const [data, setData] = useState<ZipCodeReturn | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!validateZipCodeStructure(zipCode) || blockRequest) {
      return setData(null);
    } else {
      setIsLoading(true);
      api
        .get(`/core/enderecos/${zipCode.replace(/-/g, "")}`)
        .then((response) => {
          setData(response.data);
        })
        .catch(() => {
          setData(null);
        })
        .finally(() => setIsLoading(false));
    }
  }, [blockRequest, zipCode]);

  return { data, isLoading };
};
